<template>
    <div class="v-success-modal">
      <div class="v-success-modal__main">
        <v-icon type="iconcheck_circle_outline-24px" size="74"></v-icon>
        <h2>{{title}}</h2>
        <p>{{countDown}}秒后自动跳转到登录页面，如果没有跳转请点击下方跳转按钮</p>
      </div>
      <Button type="primary"
              shape="circle"
              long
              @click="handleToLogin">返回到登录页面</Button>
    </div>
</template>

<script>
let timer = null;
export default {
  name: 'index',
  props: {
    title: {
      default: '操作成功!',
      type: String,
    },
    countDown: {
      default: 3,
      type: [Number, String],
    },
  },
  data() {
    return {
      countDownTime: 3,
    };
  },
  created() {
    this.countDownTime = this.countDown;
    this.handleCountDown();
  },
  methods: {
    handleCountDown() {
      timer = setInterval(() => {
        this.countDown -= 1;
        if (this.countDown <= 0) {
          this.handleToLogin();
        }
      }, 1000);
    },
    handleToLogin() {
      clearInterval(timer);
      this.$router.replace({
        name: 'login',
      });
    },
  },
  beforedestroy() {
    clearInterval(timer);
  },
};
</script>

<style lang="less">
  .v-success-modal{
    width: 560px;
    height: 432px;
    box-shadow: 0 16px 24px 2px rgba(0, 0, 0, .1),
    0 6px 30px 5px rgba(0, 0, 0, .08),
    0 8px 10px 0 rgba(0, 0, 0, .16);
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin-top: -20px;
    padding: 0 16px;
    &__main{
      text-align: center;
      padding-top: 24px;
      margin-bottom: 156px;
      .v-icon{
        color: rgba(0, 0, 0, 0.26);
      }
      h2{
        margin-top: 16px;
        color: rgb(81, 69, 139);
        font-size: 24px;
        line-height: 32px;
        margin-bottom: 2px;
      }
      p{
        color: rgba(0, 0, 0, 0.54);
        font-size: 12px;
        line-height: 16px;
      }
    }
    .ivu-btn{
      padding: 0;
      height: 36px;
      font-size: 14px;
      font-weight: 500;
    }
  }
</style>
